import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'

/** A qué WhatsApp salen la cotización y el acta de una orden (0273). */
export type WhatsAppDeEnvio = {
  orden_servicio_id: string
  /** El que se usa: el de la orden si se puso; si no, el del cliente. */
  whatsapp: string | null
  /** 'orden': puesto solo para esta orden · 'cliente': el del cliente · null: ninguno. */
  origen: 'orden' | 'cliente' | null
  del_cliente: string | null
}

const CLAVE = 'whatsapp-de-envio'

/** Por la orden o, en las pantallas de envío, por la cotización. */
export function useWhatsAppDeEnvio(donde: { ordenServicioId?: string; cotizacionId?: string }) {
  return useQuery({
    queryKey: [CLAVE, donde.ordenServicioId ?? null, donde.cotizacionId ?? null],
    enabled: Boolean(donde.ordenServicioId || donde.cotizacionId),
    queryFn: async (): Promise<WhatsAppDeEnvio | null> => {
      const { data, error } = await supabase.rpc('fn_whatsapp_de_envio', {
        p_orden_servicio_id: donde.ordenServicioId ?? null,
        p_cotizacion_id: donde.cotizacionId ?? null,
      })
      if (error) throw new Error(mensajeDeError(error))
      return ((data as WhatsAppDeEnvio[] | null) ?? [])[0] ?? null
    },
  })
}

/** Lo cambia para esta orden. Vacío: vuelve al del cliente. */
export function useCambiarWhatsAppDeEnvio() {
  const cliente = useQueryClient()

  return useMutation({
    mutationFn: async ({
      ordenServicioId,
      numero,
    }: {
      ordenServicioId: string
      numero: string
    }): Promise<void> => {
      const { error } = await supabase.rpc('fn_cambiar_whatsapp_de_la_orden', {
        p_orden_servicio_id: ordenServicioId,
        p_numero: numero,
      })
      if (error) throw new Error(mensajeDeError(error))
    },
    onSuccess: async () => {
      await cliente.invalidateQueries({ queryKey: [CLAVE] })
      await cliente.invalidateQueries({ queryKey: ['bitacora'] })
    },
  })
}

/** 573001234567 → «300 123 4567», como se dicta. */
export function celularLegible(numero: string | null): string {
  const d = (numero ?? '').replace(/\D/g, '')
  const local = d.length === 12 && d.startsWith('57') ? d.slice(2) : d
  return local.length === 10
    ? `${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6)}`
    : numero ?? ''
}
